<template>
    <div></div>
</template>

<script>
    import L from 'leaflet';
    import 'leaflet-sleep';
    import markerHtml from '../resources/marker-primary.html';

    export default {
        props: {
            pins: {
                type: [Array, null],
                default: null,
            },
            center: {
                type: [Array, null],
                default: null,
            },
        },

        data() {
            return {
                map: null,
                markers: [],
            };
        },

        computed: {
            locations() {
                if (this.center) {
                    return [{
                        location: this.center,
                    }];
                }

                return this.pins;
            },
        },

        watch: {
            pins() {
                this.setMapPins();
            },
            center() {
                this.setMapPins();
            },
        },

        mounted() {
            this.map = L.map(this.$el, {
                attributionControl: false,
                zoomControl: false,
                // sleepOpacity: 0.5,
                layers: [
                    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                    }),
                ],
            });

            L.control.zoom({
                position: 'bottomleft',
            }).addTo(this.map);

            L.control.attribution({
                position: 'bottomright',
            }).addTo(this.map);

            this.setMapPins();

            this.$events.$on('changeTab', this.onResize);
        },

        beforeDestroy() {
            this.$events.$off('changeTab', this.onResize);
        },

        methods: {
            setMapPins() {
                for (const marker of this.markers) {
                    this.map.removeLayer(marker);
                }

                const latLngBounds = new L.latLngBounds();

                for (const location of this.locations) {
                    latLngBounds.extend(new L.latLng(location.location));

                    const icon = L.divIcon({
                        html: markerHtml,
                        iconSize: [24, 31.75],
                    });

                    const marker = L.marker(new L.latLng(location.location), { icon });
                    this.map.addLayer(marker);

                    if (location.name) {
                        let popup = `<strong>${location.name}</strong>`;
                        if (location.address) {
                            popup += `<br />${location.address}`;
                        }

                        marker.bindPopup(popup);
                    }

                    this.markers.push(marker);
                }

                if (this.markers.length > 0 && this.locations[0].name) {
                    const [ marker ] = this.markers;
                    marker.openPopup();
                }

                this.map.fitBounds(latLngBounds, {
                    maxZoom: 14,
                    padding: [50, 50],
                });
            },

            onResize() {
                this.$nextTick(() => {
                    this.map.invalidateSize();
                });
            },
        },
    };
</script>
